import { SxProps } from "@mui/material";

export const sxLabel: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 600,
  marginBottom: '8px'
}

export const sxButtonText: SxProps = {
  textDecoration: 'underline',
  textTransform: 'none',
  fontFamily: 'Unimed-Sans',
  fontWeight: 600,
  padding: 0,
  '&:hover': {
    color: '#164029',
  }
}
export const sxCalendar: SxProps = {

  width: '100%',
  ".MuiDateCalendar-root": {
      backgroundColor: '#00995D',
      boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08);'
  },
  ".MuiPickersCalendarHeader-root": {
      backgroundColor: '#00995D',
      color: '#fff',
      textTransform: 'uppercase',
      borderRadius: '10px 10px 0px 0px',
      paddingTop: '15px',
      paddingBottom: '15px',
      margin: '0',
      maxHeight: 'none',
  },
  ".MuiPickersCalendarHeader-labelContainer": {
      fontFamily: 'Unimed-Sans',
      fontWeight: '700',

  },
  ".MuiDayCalendar-root": {
      backgroundColor: "#fff"
  },
  ".MuiPickersCalendarHeader-switchViewButton": {
      color: '#fff'
  },
  ".MuiPickersArrowSwitcher-button": {
      color: '#fff'
  },
  ".MuiDayCalendar-weekDayLabel": {
      fontFamily: 'Unimed-Sans',
      fontWeight: '700',
      color: '#4C4C4C'
  },
  ".MuiPickersDay-root": {
      fontFamily: 'Unimed-Sans',
      color: '#4C4C4C',
      backgroundColor: '#fff'
  },
  "MuiPickersDay-root:focus": {
      backgroundColor: '#00995D'
  },
  "MuiPickersDay-root:hover": {
      backgroundColor: '#000'
  },
  ".MuiPickersYear-yearButton": {
      fontFamily: 'Unimed-Sans',
      color: '#4C4C4C'
  },
  ".Mui-selected": {
      backgroundColor: '#00995D',
      color: "#fff"
  },
  ".Mui-selected:focus": {
      backgroundColor: '#00995D'
  },
  ".Mui-selected:hover": {
      backgroundColor: '#00995D'
  },
  ".Mui-disabled": {
      background: 'none'
  },
  '.MuiButton:hover .MuiButton-contained': {
      backgroundColor: '#00995D',
  }
}

export const sxCalendarContrast: SxProps = {
  ...sxCalendar,
    '& .MuiInputBase-root': {
      backgroundColor: 'black',
      color: 'white',
    },
    '& .MuiSvgIcon-root': {
      color: 'white',
    },
}


export const sxPagination: SxProps = {
  width: 'auto',
  height: '32px',
  background: 'unset',
  color: 'unset',
  fontSize: 'unset',
  fontStyle: 'unset',
  fontWeight: 'unset',
  lineHeight: 'unset',
  position: 'unset',
  button: {
    fontFamily: 'UnimedSans-Bold',
    backgroundColor: '#EEE',
    color: '#5F5F5F'
  }
}

export const sxButtonBuscar: SxProps = {
  fontFamily: 'Unimed-Sans',
  borderRadius: '80px',
  padding: '10px 32px '
}

export const sxTitleResult: SxProps = {
  fontSize: 20,
  fontFamily: 'UnimedSans-Bold',
  width: '100%',
  color: '#383838',
}

export const sxTitleTableResult: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  marginTop: '30px',
  marginBottom: '15px'
}

export const sxTable: SxProps = {
  borderRadius: '10px',
  width: '100%',
  '@media (max-width: 360px)': {
    maxWidth: '230px'
  },
  '@media (max-width: 320px)': {
    maxWidth: '200px'
  }
}